import { stripHtml } from './stripHtml';

/**
 * Sort pesticide group associations alphanumerically by group name for the
 * client site display (spec "ordre d'affichage" — Groupes de pesticides :
 * ordre alphabétique ou alphanumérique). The admin keeps the input order, so
 * this must stay a display-time sort.
 *
 * Sorting whole association objects keeps the related fields (famille
 * chimique, risque de résistance, commentaires) aligned with their group.
 */
export const sortPesticideGroupAssociations = (associations) => {
  if (!Array.isArray(associations)) return [];
  return [...associations].sort((a, b) =>
    stripHtml(a?.pesticide_group?.name || '').localeCompare(
      stripHtml(b?.pesticide_group?.name || ''),
      'fr',
      { numeric: true, sensitivity: 'base' }
    )
  );
};
